<template>
  <div class="dialog-wap">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      :before-close="handleClose"
      class="error-dialog"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            服务商合同模版配置
          </h4>
        </div>
      </template>
      <el-form
        ref="formRef"
        class="add-platform-users-form"
        require-asterisk-position="right"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="contractTempId" label="选择合同模版">
          <el-select
            v-model="form.contractTempId"
            placeholder="请选择合同模版"
            clearable
            filterable
          >
            <el-option
              v-for="item in dutyContractConfigDTOOptions"
              :key="item.id"
              :label="item.tempName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            :loading="saveBtnLoading" @click="handleClose"
          >
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">

import { PropType, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { queryContractTempAvailableTemp } from '@core/main';
import { EFreelancerDutyType, EProxyPayType, ETempBusiness, IContractTempDO, IServerContractTempItem } from '@core/main/types';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IServerContractTempItem>,
    default: () => {},
  },
});

const emit = defineEmits(['close', 'confirm']);

const saveBtnLoading = ref(false);
const formRef = ref();

const form = ref({ contractTempId: null });
const dutyContractConfigDTOOptions = ref([] as IContractTempDO[]);
const formRules = ref({
  contractTempId: [
    {
      message: '请选择合同模版',
      required: true,
    },
  ],
});

function handleClose() {
  formRef.value.resetFields();
  emit('close');
}

function handleSubmit() {
  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

async function doSubmit() {
  emit('confirm', form.value.contractTempId);
}

async function fetchTastContractTempOptions() {
  let params = [];

  if (props.row?.businessType == EFreelancerDutyType.CROWD) {
    if (props.row?.proxyPayType == EProxyPayType.LABOR_REMUNERATION) {
      params = [ETempBusiness.CROWD_LABOR_FREELANCER_CONTRACT];
    } else {
      params = [ETempBusiness.FREELANCER_CONTRACT];
    }
  } else if (props.row?.businessType == EFreelancerDutyType.MATCH) {
    params = [ETempBusiness.BROKER_COLLECTION_CONTRACT];
  }
  try {
    const res = await queryContractTempAvailableTemp(params);

    dutyContractConfigDTOOptions.value = res;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

watch(
  [
    () => props.visible,
    () => props.row,
  ],
  () => {
    if (props.visible) {
      fetchTastContractTempOptions();
      form.value.contractTempId = props.row.contractTempId;
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.dialog-wap {
  :deep(.el-dialog__body) {
    padding-bottom: 6px;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
